"use strict";
// Copyright © 2021 Move Closer
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArticleAuthor = void 0;
const vue_property_decorator_1 = require("vue-property-decorator");
const front_1 = require("../../../dsl/front");
/**
 * @author Sebastian Dziechciarz <sebastian.dziechciarz@movecloser.pl>
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Michał Rossian <michal.rossian@movecloser.pl>
 */
let ArticleAuthor = class ArticleAuthor extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        /**
         * The present as `Date` object
         */
        this.now = new Date();
    }
    /**
     * Determines whether the article's publication date is newer than `this.now`.
     */
    get isFutureDate() {
        try {
            if (!this.publicationDate) {
                return true;
            }
            return new Date(this.publicationDate) > this.now;
        }
        catch (e) {
            console.warn(e);
            return false;
        }
    }
    /**
     * Article's publication time as `PublicationTime` enum.
     */
    get publicationTime() {
        if (typeof this.publicationDate !== 'string' || this.publicationDate.length === 0) {
            return '';
        }
        try {
            const date = new Date(this.publicationDate);
            const d = date.getDate().toString().padStart(2, '0');
            const m = (date.getMonth() + 1).toString().padStart(2, '0');
            const y = date.getFullYear().toString().padStart(2, '0');
            if (this.shortenDate) {
                return `${d}.${m}.${y}`;
            }
            else {
                const t = `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}`;
                return `${d}.${m}.${y} ${t}`;
            }
        }
        catch (e) {
            // In case if error occurs while formatting with format()
            const [date, time] = this.publicationDate.split('T');
            if (time) {
                return date.replace(/-/g, '.') + ' ' + (time.split(':')[0] + ':' + time.split(':')[1]);
            }
            else {
                return '';
            }
        }
    }
};
__decorate([
    vue_property_decorator_1.Prop({ type: Object, required: false, default: () => ({}) }),
    __metadata("design:type", Object)
], ArticleAuthor.prototype, "avatar", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], ArticleAuthor.prototype, "hideDate", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: true }),
    __metadata("design:type", String)
], ArticleAuthor.prototype, "name", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: String, required: false, default: null }),
    __metadata("design:type", Object)
], ArticleAuthor.prototype, "publicationDate", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], ArticleAuthor.prototype, "shortenDate", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: true }),
    __metadata("design:type", Boolean)
], ArticleAuthor.prototype, "showAuthorAvatar", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: true }),
    __metadata("design:type", Boolean)
], ArticleAuthor.prototype, "showAuthorName", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: false }),
    __metadata("design:type", Boolean)
], ArticleAuthor.prototype, "showInitialsWhenNoAvatar", void 0);
__decorate([
    vue_property_decorator_1.Prop({ type: Boolean, required: false, default: true }),
    __metadata("design:type", Boolean)
], ArticleAuthor.prototype, "showPublicationDate", void 0);
ArticleAuthor = __decorate([
    vue_property_decorator_1.Component({
        name: 'ArticleAuthor',
        components: { BootstrapImage: front_1.BootstrapImage },
        template: `
    <div class="article-author">
    <!-- Avatar -->
    <BootstrapImage v-if="showAuthorAvatar && avatar && avatar.src && avatar.src.length"
                    v-bind="avatar" class="article-author__avatar img-avatar me-4"/>
    <div v-else-if="showInitialsWhenNoAvatar" class="article-author__initials mr-3">
      {{ name.split(' ')[0][0] }}{{ name.split(' ')[1][0] }}
    </div>

      <!-- Text data -->
      <p class="article-author__texts">
        <span v-if="showAuthorName && name && name.length"
              class="article-author__name text-ui-small text-uppercase">
          {{ name }}
        </span>
        <template v-if="!hideDate">
          <time v-if="showPublicationDate && publicationDate && publicationTime"
                :datetime="new Date(publicationDate).toISOString()" class="article-author__publication-time fs-small">
            {{ !isFutureDate ? publicationTime : $t('modules.tile.futureDate') }}
          </time>
        </template>
      </p>
    </div>
  `
    })
], ArticleAuthor);
exports.ArticleAuthor = ArticleAuthor;
//# sourceMappingURL=ArticleAuthor.js.map